import { render, staticRenderFns } from "./ModalRelatorio.vue?vue&type=template&id=8f9531b2&scoped=true&"
import script from "./ModalRelatorio.vue?vue&type=script&lang=js&"
export * from "./ModalRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./ModalRelatorio.vue?vue&type=style&index=0&id=8f9531b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9531b2",
  null
  
)

export default component.exports